import { Theme } from "theme/themeTypes";

export const lightTheme: Theme = {
  primary: "#5d46e5",
  bodyBg: "#ffffff",
  contentBg: "#f6f5ff",
  text: "#000000",
  header: "#f6f5ff",
  inputBg: "#f5f5f5",
  transparentInputBg: "transparent",
  inputBorder: "white",
  offRangeBg: "#E6E3FF",
  calendarBorder: "#e6e3ff",
  calendarCellText: "#5d46e5",
  calendarHeaderText: "#5d46e5",
  calendarTodayBg: "#f6f5ff",
  menuItemText: "#5d46e5",
  menuItemHover: "#f6f5ff",
  menuItemSelected: "#5d46e5",
  triggerBg: "#E6E3FF",
  avatarBg: "#E6E3FF",
  profileAvatarBg: "#E6E3FF",
  cardBg: "#ffffff",
  title: "#5d46e5",
  placeholder: "#c9c2f0",

  formPlaceholder: "#B4B4B4",
  stepBg: "white",
  stepIcon: "white",
  completedStepIcon: "white",
  stepSeperator: "white",
  completedStepBorder: "white",
};
